import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';
import MSICCodeJson from 'src/assets/data/einvoice-msic-code.json';

@Component({
  selector: 'app-einvoice-msic-code-select',
  templateUrl: './einvoice-msic-code-select.component.html',
  styleUrls: ['./einvoice-msic-code-select.component.less'],
  styles: [],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    ViewItemComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceMsicCodeSelectComponent),
      multi: true
    }
  ]
})
export class EInvoiceMsicCodeSelectComponent implements ControlValueAccessor {
  options = [...MSICCodeJson];

  @Input() value: string = '';
  @Input() disabled = false;
  @Input() borderless = false;
  @Input() isRequired = false;

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.code === this.value);
    if (item) return item.code + ' - ' + item.description;
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
